import { useDesignMaxTheme } from "@/packages";
import { useCleanText } from "@/shared/client";
import { FONT } from "@/styles";
import { removeHtmlTags } from "@/utils";
import { Box, Flex, Text } from "@chakra-ui/react";
import { useLocation } from "react-router-dom";
import { type CatchPraiseProps } from "./catchPraise.type";

export const CatchPraise = ({ catchPraise, annotation, isDetail }: CatchPraiseProps) => {
    const { main, sub } = catchPraise;
    const { pathname } = useLocation();
    const { MEDIAS } = useDesignMaxTheme();
    const { isMobile, isTablet } = MEDIAS();

    const isMainEnglish = /^[a-zA-Z\s,.'";:!?&()-]+$/.test(main.firstLine);
    const isSubEnglish = /^[a-zA-Z\s,.'";:!?&()-]+$/.test(sub.firstLine);

    const { cleanText } = useCleanText(sub.secondLine);

    let mainFontSize = 52;
    if (isTablet) mainFontSize = 32;
    if (isMobile) mainFontSize = 24;

    return (
        <Flex
            flexDir="column"
            rowGap="16px"
            textAlign="left"
            sx={{
                "& .main_kr": { ...FONT("notoSerif", mainFontSize, 500, 1.2) },
                "& .main_en": { ...FONT("cormorant", mainFontSize, 500, 1.2) },
                "& .sub_kr": { ...FONT("notoSerif", isMobile ? 14 : 16, 500, 1.2) },
                "& .sub_en": { ...FONT("cormorant", isMobile ? 14 : 16, 500, 1.2) },
            }}
        >
            <Box position="relative" pl={isMobile ? "20px" : "36px"}>
                {annotation && (
                    <Text className="catch_praise_annotation" sx={{ ...FONT("cormorant", 20, 700, 1.2) }}>
                        {annotation}
                    </Text>
                )}
                <Text className={isMainEnglish ? "main_en" : "main_kr"}>
                    {main.firstLine ? removeHtmlTags(main.firstLine, "<br>").cleanText : ""}
                </Text>
                {main.secondLine && (
                    <Text className={isMainEnglish ? "main_en" : "main_kr"}>
                        {main.secondLine ? removeHtmlTags(main.secondLine, "<br>").cleanText : ""}
                    </Text>
                )}
            </Box>
            <Flex pl={isMobile ? "20px" : "36px"} flexDir="column" rowGap="16px">
                <Text className={isSubEnglish ? "sub_en" : "sub_kr"}>
                    {sub.firstLine ? removeHtmlTags(sub.firstLine, "<br>").cleanText : ""}
                </Text>
                {sub.secondLine && (
                    <Text>
                        <Flex flexDir="column" gap="4px">
                            {Array.isArray(cleanText)
                                ? cleanText.map((text) => (
                                      <Text
                                          as="p"
                                          key={text}
                                          w={isDetail || pathname.includes("rooms") ? "auto" : "360px"}
                                          textOverflow={isDetail ? "" : "hidden"}
                                          whiteSpace={isDetail || pathname.includes("/rooms") ? "wrap" : "nowrap"}
                                          className={isSubEnglish ? "sub_en" : "sub_kr"}
                                      >
                                          {text}
                                      </Text>
                                  ))
                                : cleanText}
                        </Flex>
                    </Text>
                )}
            </Flex>
        </Flex>
    );
};
